import LegalPagesStyle from "../../styles/LegalPages.module.scss";
import Image from "next/image";
import LegalService from "../../services/legal.service";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { ArrowLeft } from "react-feather";

const PrivacyPolicy = ({ props }) => {
  const router = useRouter();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pageType, setPageType] = useState(null);
  const [pageTitle, setPageTitle] = useState(null);

  useEffect(() => {
    (async function () {
      let dataTypeToLoad = null;
      if (router.query && router.query.page) {
        const page = router.query.page;

        switch (page) {
          case "terms-of-use":
            setPageType("terms");
            setPageTitle("Terms of use");
            dataTypeToLoad = "getTermsOfUse";
            break;

          case "privacy":
            setPageType("privacy");
            setPageTitle("Privacy policy");
            dataTypeToLoad = "getPrivacyPolicy";
            break;

          case "cookies":
            setPageType("cookies");
            setPageTitle("Cookies policy");
            dataTypeToLoad = "getCookiesPolicy";
            break;

          case "tracker-terms-of-use":
            setPageType("cookies");
            setPageTitle("Tracker terms of use");
            dataTypeToLoad = "getTrackerPolicy";
            break;
        }

        // setPageType(page === 'terms-of-use' ? 'terms' : 'privacy');
        // setPageTitle(page === 'terms-of-use' ? 'Terms of use' : 'Privacy policy');

        const pageContent = await LegalService[dataTypeToLoad]();

        const content = Array.isArray(pageContent.data) ? pageContent.data[0].attributes.Content : pageContent.data.attributes.Content;

        setContent(content);
      }

      setLoading(false);
    })();
  }, [router.query]);

  const agreedToTermsOfUse = async () => {
    // Set as agreed to terms of use and redirect
  };

  const goBack = () => {
    history.back();
  };

  return (
    <main id={LegalPagesStyle.main}>
      <div id={LegalPagesStyle.logo}>
        <span>
          <img alt={"GTI"} src={"/images/gtiLogo.svg?cb=legal-50122122"} style={{ width: "46px" }} />
        </span>
        &nbsp; GTI
      </div>

      <h1>{pageTitle}</h1>
      <div className={LegalPagesStyle.contentWrapper} dangerouslySetInnerHTML={{ __html: content }}></div>

      {pageType !== "cookies" && (
        <div className={LegalPagesStyle.backButton} onClick={(ev) => goBack()}>
          <ArrowLeft size={22} /> Go back
        </div>
      )}

      {pageType === "terms" && router.query.approve && <button onClick={() => agreedToTermsOfUse()}>I agree to the terms of use</button>}
    </main>
  );
};

export default PrivacyPolicy;
